import { IconCheckDefault } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

type ConfirmedModalProps = {
    isOpen: boolean;
    onGoToDashboard: () => void;
};

export const ConfirmedModal = ({
    isOpen,
    onGoToDashboard
}: ConfirmedModalProps) => {
    if (!isOpen) return null;

    return (
        <div className="flex flex-col items-center gap-xl px-xl py-2xl text-center">
            <div className="h-24 w-24 flex items-center justify-center rounded-full bg-success-lt">
                <IconCheckDefault className="text-5xl text-success-drk" />
            </div>
            <div className="flex flex-col gap-m">
                <Text className="text-2xl font-bold">
                    <FormattedMessage
                        id="_.credit_card_waitlist.confirmed_title"
                        defaultMessage="We've registered your interest"
                    />
                </Text>
                <div className="space-y-s text-structure-40">
                    <Text>
                        <FormattedMessage
                            id="_.credit_card_waitlist.confirmed_body_line1"
                            defaultMessage="We'll email you at the address on your account when the iwoca Credit Card becomes available to you."
                        />
                    </Text>
                    <Text>
                        <FormattedMessage
                            id="_.credit_card_waitlist.confirmed_body_line2"
                            defaultMessage="You won't need to do anything else."
                        />
                    </Text>
                </div>
            </div>
            <button
                onClick={onGoToDashboard}
                className="rounded-full px-l py-m text-m font-med text-white transition-colors"
                style={{ backgroundColor: '#07172b' }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#0a1f3a';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#07172b';
                }}
            >
                <FormattedMessage
                    id="_.credit_card_waitlist.go_to_dashboard"
                    defaultMessage="Go to dashboard"
                />
            </button>
        </div>
    );
};
